var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "contact-data" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("address")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("address_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c("address-input", {
            attrs: { required: "", expanded: "", hideLabel: "" },
            model: {
              value: _vm.formData.address,
              callback: function($$v) {
                _vm.$set(_vm.formData, "address", $$v)
              },
              expression: "formData.address"
            }
          })
        ],
        1
      )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("contact")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("contact_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c("email-input", {
            attrs: { hideLabel: "" },
            model: {
              value: _vm.formData.email,
              callback: function($$v) {
                _vm.$set(_vm.formData, "email", $$v)
              },
              expression: "formData.email"
            }
          }),
          _c("phone-input", {
            attrs: { hideLabel: "" },
            model: {
              value: _vm.formData.phone,
              callback: function($$v) {
                _vm.$set(_vm.formData, "phone", $$v)
              },
              expression: "formData.phone"
            }
          })
        ],
        1
      )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("bank_details")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c("bank-details-input", {
            attrs: { expanded: "", hideLabel: "" },
            model: {
              value: _vm.formData.bankDetails,
              callback: function($$v) {
                _vm.$set(_vm.formData, "bankDetails", $$v)
              },
              expression: "formData.bankDetails"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }